'use client';

import type { ChangeEvent } from 'react';
import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import { FormGroup } from '../../templates/form-group/form-group';
import type { TextInputProps } from './text-input.types';

function getContainerStyle(withButton: boolean) {
  if (withButton)
    return 'hc-input__container--with-button hc-sidebar-layout--reverse';

  return '';
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      icon,
      helpText,
      errorText,
      disabled,
      error,
      name,
      id,
      withButton = false,
      button,
      className,
      required,
      placeholder,
      defaultValue,
      onChange,
      onBlur,
    },
    ref,
  ) => {
    const showErrors =
      error ||
      (!!errorText && !!(errorText as React.ReactElement)?.props?.children);
    const inputId = id || name;

    return (
      <FormGroup className={className} disabled={disabled} error={showErrors}>
        <label className="hc-label">
          {label}
          <div className={getContainerStyle(withButton)}>
            <div className="hc-form-control--icon-right relative">
              <IMaskInput
                onBlur={onBlur}
                onAccept={(_v, _r, e) => {
                  if (e) {
                    // Required to work with react hook form as IMask Uses onAccept instead of onChange.
                    onChange?.(e as unknown as ChangeEvent<HTMLInputElement>);
                  }
                }}
                inputRef={ref}
                mask="text"
                blocks={{
                  text: {
                    mask: /^[a-zA-Z-]+$/i,
                  },
                }}
                lazy={false}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                name={name}
                id={inputId}
                aria-invalid={showErrors}
                defaultValue={defaultValue}
              />
              {icon}
            </div>
            {button}
          </div>
        </label>
        <div className="hc-help-text">{helpText}</div>
        <div className="hc-error-text">{errorText}</div>
      </FormGroup>
    );
  },
);
